import { Phone } from "lucide-react";
import { Button } from "@/components/ui/button";

export const FloatingContactButton = () => {
  const handleContactClick = () => {
    const element = document.getElementById('contactez-nous');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'nearest'
      });
    }
  };

  return (
    <Button
      onClick={handleContactClick}
      className="fixed bottom-6 right-6 z-50 bg-orange-500 hover:bg-orange-600 text-white px-6 py-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center space-x-2 font-semibold"
    >
      <Phone className="h-5 w-5" />
      <span className="hidden sm:inline">Contactez-nous</span>
      <span className="sm:hidden">Contact</span>
    </Button>
  );
};